<template>
  <el-dialog
    title="Change role"
    :visible.sync="shouldShow"
    @close="closeEvent"
    width="30%"
  >
    <el-form :model="form" label-position="top" ref="form">
      <el-row type="flex" class="is-flex-wrap">
        <el-col :md="24">
          <el-form-item label="Role" prop="role">
            <el-select v-model="form.role" placeholder="Select role">
              <el-option
                v-for="(value, key, index) in roles()"
                :key="index"
                :label="value"
                :value="key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="closeEvent">Cancel</el-button>
      <el-button
        type="primary"
        :loading="changing"
        @click="changeRole"
        :disabled="role === form.role"
        >Change role</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import member from "@/requests/settings/members/member";

export default {
  name: "MemberRoleChange",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    role: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      changing: false,
      form: {
        role: "",
      },

      memberRoles: [
        "Super Admin",
        "Admin",
        "Gardener",
        "Gardener Pro",
        "Growth",
        "Operations",
        "Kitchen",
        "Steward",
        "OFA",
      ],
    };
  },
  watch: {
    show() {
      if (this.show) {
        this.form.role = this.role;
      }
    },
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    closeEvent() {
      this.shouldShow = false;
      this.$refs.form.resetFields();
    },
    changeRole() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.changing = true;
        member
          .role(this.id, this.form)
          .then((response) => {
            if (response.data.status) {
              this.$message.success(response.data.message);
              this.changing = false;
              this.$emit("success", this.form.role);
              this.closeEvent();
            }
          })
          .catch((error) => {
            this.changing = false;
            const errorMessage = error.response.data;
            if (errorMessage.errors) {
              const errorKeys = Object.keys(errorMessage.errors);
              this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
            } else {
              this.$message.error(errorMessage.message);
            }
          });
        return true;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
